import { apiNames, get, fetchQuery } from './shared';

export const businessTypesUrl = 'business-types';
export const businessTypesByMemberTypeUrl = 'member-types/primary-business-types';

export const fetchBusinessTypes = () => fetchQuery({ fetchRequest: () => get(apiNames.MEMBERSHIP, businessTypesUrl) });
export const fetchBusinessTypesByMemberType = () =>
    fetchQuery({ fetchRequest: () => get(apiNames.MEMBERSHIP, businessTypesByMemberTypeUrl) });
